import React from "react";
import { cn } from "../../lib/utils";

interface EDSTabsProps {
  tabs: Array<{
    id: string;
    label: string;
  }>;
  selectedTab: string;
  onTabChange: (tabId: string) => void;
  className?: string;
}

const EDSTabs: React.FC<EDSTabsProps> = ({
  tabs,
  selectedTab,
  onTabChange,
  className
}) => {
  return (
    <div className={cn("eds-tabs inline-flex items-center", className)}>
      <div
        className="eds-tabs__container eds-tabs-container"
        role="tablist"
        aria-label="Toggle options"
      >
        {tabs.map((tab) => {
          const isActive = selectedTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`eds-tabs__tab eds-tabs-tab ${isActive ? "eds-tabs__tab--active eds-tabs-tab-active" : ""}`}
              role="tab"
              aria-selected={isActive}
              aria-controls={`tabpanel-${tab.id}`}
            >
              {tab.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default EDSTabs;
